import axios from 'axios'
// import _ from "lodash"
import treeHandler from '@/services/treeHandler'
import eventsOddsHandler from '@/services/eventsOddsHandler'
import rulesHandler from '@/services/rulesHandler'

import filter from 'lodash/filter'
import size from 'lodash/size'
import first from 'lodash/first'

const state = {
  filter: 0,
  tree: [],
  qbet: false,
  print: false,
}

const getters = {
  getTree(state) {
    return state.tree
  },

  getFilter(state) {
    return state.filter
  },
  getQbet(state) {
    return state.qbet
  },
  getPrint(state) {
    return state.print
  },
}

const actions = {
  async fetchFullSport(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-sports`

    // Get Tree
    return axios
      .post(
        `${url}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )

      .then(async res => {
        return res.data.data

        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(err => {
        console.log(err)
      })
  },
  async fetchMarketSport(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-markets-sports`

    // Get Tree
    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(async res => {
        return res.data.markets
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(err => {
        console.log(err)
      })
  },
  async fetchMarketSportQuickbet(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-markets-sports-quickbet`

    // Get Tree
    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(async res => {
        return res.data.markets
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(err => {
        console.log(err)
      })
  },
  async fetchMarketSportQuickbetAdmin(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-markets-sports-quickbet-admin`

    // Get Tree
    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(async res => {
        return res.data.markets
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(err => {
        console.log(err)
      })
  },
  async fetchMarketGuideQuickbet(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-markets-guide-quickbet`

    // Get Tree
    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(async res => {
        return res.data.markets
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(err => {
        console.log(err)
      })
  },
  async fetchCategorySport(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-categories`

    // Get Tree
    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(async res => {
        const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
        const rules = {
          manager: context.rootGetters['rules/getRulesManager'],
          skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
          lang: context.rootGetters['settings/getLanguage'],
        }

        const promise = []
        for (const cat of res.data.categories) {
          promise.push(
            rulesHandler.applyRulesToObject(cat, rules, onlyManager, cat.id)
          )
        }

        let filtered = []
        await Promise.all(promise).then(result => {
          filtered = filter(result, category => {
            return (
              category.status_rule == undefined || category.status_rule == true
            )
          })
        })

        return filtered

        //return res.data.categories
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(err => {
        console.log(err)
      })
  },
  async fetchTournamentByCategory(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-tournaments-category`

    // Get Tree
    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(async res => {
        const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
        const rules = {
          manager: context.rootGetters['rules/getRulesManager'],
          skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
          lang: context.rootGetters['settings/getLanguage'],
        }

        const promise = []
        for (const tourn of res.data.data) {
          promise.push(
            rulesHandler.applyRulesToObject(tourn, rules, onlyManager, tourn.id)
          )
        }

        let filtered = []
        await Promise.all(promise).then(result => {
          filtered = filter(result, tournament => {
            return (
              tournament.status_rule == undefined ||
              tournament.status_rule == true
            )
          })
        })

        return filtered

        //return res.data.data
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(err => {
        console.log(err)
      })
  },
  async fetchMarketSportPrint(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-markets-sports-printodds`

    // Get Tree
    return axios
      .post(`${url}`, payload, {
        headers: {
          Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
        },
      })

      .then(async res => {
        return res.data.markets
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(err => {
        console.log(err)
      })
  },

  async fetchTree(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/api/get-tree`

    // Get Tree
    await axios
      .post(
        `${url}`,
        {
          filter: state.filter,
          id_language: context.rootGetters['settings/getLanguage'],
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )

      .then(async res => {
        const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
        const managerRules = context.rootGetters['rules/getRulesManager']
        if (!onlyManager) {
          var skinRules = context.rootGetters['rules/getRulesSkin']
        }

        const rulesSchema = {
          sportManager: filter(managerRules, { scope: 'sport' }).length > 0,
          categoryManager:
            filter(managerRules, { scope: 'category' }).length > 0,
          tournamentManager:
            filter(managerRules, { scope: 'tournament' }).length > 0,
          eventManager:
            filter(managerRules, { scope: 'event', type: 'disable' }).length >
            0,
          sportSkin:
            !onlyManager && filter(skinRules, { scope: 'sport' }).length > 0,
          categorySkin:
            !onlyManager && filter(skinRules, { scope: 'category' }).length > 0,
          tournamentSkin:
            !onlyManager &&
            filter(skinRules, { scope: 'tournament' }).length > 0,
          eventSkin:
            filter(managerRules, { scope: 'event', type: 'disable' }).length >
            0,
        }

        const rules = {
          manager: managerRules,
          skin: !onlyManager ? skinRules : [],
        }

        const tree = await treeHandler.refactorTree(
          res.data,
          rules,
          rulesSchema,
          context.rootGetters['settings/getLanguage']
        )

        context.commit('setTree', tree)
      })
      .catch(err => {
        console.log(err)
      })
  },
  async findEvent(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/events/find`
    return await axios
      .post(
        `${url}`,
        {
          search: payload.search,
          lang: payload.lang,
          platform: context.rootGetters['settings/getPlatformId'],
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(res => {
        return res.data.events
      })
      .catch(error => {
        console.log(error)
      })
  },
  async findEventQuick(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/events/findquick`
    return await axios
      .post(
        `${url}`,
        { search: payload.search, lang: payload.lang, sport: payload.sport },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        if (res.data.events) {
          const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage'],
          }

          const producer = 0
          const data_event = await eventsOddsHandler.refactorQuickBet(
            res.data,
            rules,
            producer,
            onlyManager
          )
          return data_event
        }
      })
      .catch(error => {
        console.log(error)
      })
  },

  async findEventMin(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/events/findquickmin`
    return await axios
      .post(
        `${url}`,
        { search: payload.search, lang: payload.lang, sport: payload.sport },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        if (res.data.events) {
          /* var onlyManager = (context.rootGetters['settings/getPlatformId'] == 0);
                    var rules = {
                        manager: context.rootGetters['rules/getRulesManager'],
                        skin: (!onlyManager) ? context.rootGetters['rules/getRulesSkin'] : [],
                        lang: context.rootGetters['settings/getLanguage']
                    }

                    var producer = 0;
                    const data_event = await eventsOddsHandler.refactorQuickBet(res.data, rules, producer, onlyManager)*/
          return res.data.events
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  async findEventSign(context, payload) {
    const url = `${context.rootGetters['settings/getUrlApi']}/events/findquickcode`

    return await axios
      .post(
        `${url}`,
        {
          search: payload.search,
          market: payload.market,
          code: payload.code,
          id: payload.id,
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`,
          },
        }
      )
      .then(async res => {
        if (res.data.events) {
          if (size(res.data.events) == 0) {
            return null
          }
          const onlyManager = context.rootGetters['settings/getPlatformId'] == 0
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage'],
          }
          res.data.events = first(res.data.events)

          let producer
          if (res.data.events.sport_event_status._attributes.status == 2) {
            producer = 1
          } else {
            producer = 0
          }

          const data_event = await eventsOddsHandler.refactorQuickBet(
            res.data,
            rules,
            producer,
            onlyManager
          )

          const outcome = _.find(data_event.event.odds[0].odds, {
            id_outcome: res.data.outcome,
          })

          if (
            data_event.event.odds &&
            (!data_event.event.odds[0].active ||
              !outcome.active ||
              !data_event.event.status)
          ) {
            return null
          } else {
            return data_event
          }
        }
      })
      .catch(error => {
        console.log(error.message)
        console.log(error.stack)
      })
  },

  // async fetchTreeFake(context, payload) {
  //
  //     var res ={
  //         data : require('@/fake_data/tree.json')
  //     }
  //
  //     let onlyManager = (context.rootGetters['settings/getPlatformId'] == 0);
  //     var managerRules = context.rootGetters['rules/getRulesManager']
  //     if(!onlyManager){
  //         var skinRules = context.rootGetters['rules/getRulesSkin']
  //     }
  //
  //     let rulesSchema = {
  //         sportManager : (filter(managerRules, {'scope': 'sport'}).length > 0),
  //         categoryManager : (filter(managerRules, {'scope': 'category'}).length > 0),
  //         tournamentManager : (filter(managerRules, {'scope': 'tournament'}).length > 0),
  //         sportSkin : (!onlyManager && filter(skinRules, {'scope': 'sport'}).length > 0),
  //         categorySkin : (!onlyManager && filter(skinRules, {'scope': 'category'}).length > 0),
  //         tournamentSkin : (!onlyManager && filter(skinRules, {'scope': 'tournament'}).length > 0),
  //     }
  //
  //     let rules = {
  //         manager: managerRules,
  //         skin: (!onlyManager) ? skinRules : []
  //     }
  //
  //     var tree = await treeHandler.refactorTree(res.data, rules, rulesSchema, context.rootGetters['settings/getLanguage'])
  //
  //     context.commit('setTree', tree);
  //
  // },

  async setFilter(context, payload) {
    context.commit('SET_FILTER', payload)
  },
  async setStatusQbet(context, payload) {
    context.commit('setQbet', payload)
  },
  async setStatusPrint(context, payload) {
    context.commit('setPrint', payload)
  },
}

const mutations = {
  setTree(state, payload) {
    state.tree = payload
  },
  SET_FILTER(state, payload) {
    state.filter = payload
  },
  setQbet(state, payload) {
    state.qbet = payload
  },
  setPrint(state, payload) {
    state.print = payload
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
